import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class As2IntegrationService {
    private readonly base = '/admin/as2';

    // ── MESSAGES ────────────────────────────────────────────────────────────

    getMessages(params: {
        page: number;
        size: number;
        partner?: string;
        status?: string;
        direction?: string;
    }) {
        return fetchWithRetry(API.get(`${this.base}/messages`, { params }));
    }

    getMessage(id: number) {
        return fetchWithRetry(API.get(`${this.base}/messages/${id}`));
    }

    dispatch(body: { epcisId: number; partnerCode: string; schemaVersion?: string }) {
        return fetchWithRetry(API.post(`${this.base}/messages/dispatch`, body));
    }

    approve(id: number, comment?: string) {
        return fetchWithRetry(API.post(`${this.base}/messages/${id}/approve`, { comment }));
    }

    reject(id: number, reason?: string) {
        return fetchWithRetry(API.post(`${this.base}/messages/${id}/reject`, { reason }));
    }

    retryAll() {
        return fetchWithRetry(API.post(`${this.base}/messages/retry`));
    }

    getRelated(id: number) {
        return fetchWithRetry(API.get(`${this.base}/messages/${id}/related`));
    }

    getXmlContent(id: number) {
        return fetchWithRetry(API.get(`${this.base}/messages/${id}/xml`));
    }

    getMdnContent(id: number) {
        return fetchWithRetry(API.get(`${this.base}/messages/${id}/mdn`));
    }

    reprocessValidation(id: number) {
        return fetchWithRetry(API.post(`${this.base}/messages/${id}/reprocess-validation`));
    }

    getStaging(id: number) {
        return fetchWithRetry(API.get(`${this.base}/messages/${id}/staging`));
    }

    saveStaging(id: number, body: Record<string, unknown>) {
        return fetchWithRetry(API.put(`${this.base}/messages/${id}/staging`, body));
    }

    // ── PARTNERS ────────────────────────────────────────────────────────────

    listPartners() {
        return fetchWithRetry(API.get(`${this.base}/partners`));
    }

    getPartner(code: string) {
        return fetchWithRetry(API.get(`${this.base}/partners/${code}`));
    }

    createPartner(body: Record<string, unknown>) {
        return fetchWithRetry(API.post(`${this.base}/partners`, body));
    }

    updatePartner(code: string, body: Record<string, unknown>) {
        return fetchWithRetry(API.put(`${this.base}/partners/${code}`, body));
    }

    setEnabled(code: string, enabled: boolean) {
        return fetchWithRetry(API.patch(`${this.base}/partners/${code}/enabled`, { enabled }));
    }

    testConnection(code: string) {
        return fetchWithRetry(API.post(`${this.base}/partners/${code}/test-connection`));
    }

    /** Built-in EPCIS template — no database epcis row required. */
    sendTest(code: string) {
        return fetchWithRetry(API.post(`${this.base}/partners/${code}/send-test`));
    }

    // ── STATS ────────────────────────────────────────────────────────────────

    getStats() {
        return fetchWithRetry(API.get(`${this.base}/stats`));
    }
}

const as2IntegrationService = new As2IntegrationService();
export default as2IntegrationService;
